import { DeleteInvitationOutDto, DeleteInvitationInDto } from '../../../types/invitation.dto'

export const DELETE_INVITATION = 'DELETE_INVITATION'
export const DELETE_INVITATION_SUCCESS = 'DELETE_INVITATION_SUCCESS'
export const DELETE_INVITATION_ERROR = 'DELETE_INVITATION_ERROR'
export const RESET_DELETE_INVITATION = 'RESET_DELETE_INVITATION'

export interface DeleteInvitation {
  type: typeof DELETE_INVITATION
  payload: DeleteInvitationOutDto
}

export interface DeleteInvitationSuccess {
  type: typeof DELETE_INVITATION_SUCCESS
  payload: DeleteInvitationInDto
}

export interface DeleteInvitationError {
  type: typeof DELETE_INVITATION_ERROR
  payload: string | boolean
}

export interface ResetDeleteInvitation {
  type: typeof RESET_DELETE_INVITATION
  payload: null
}

export interface State {
  data: DeleteInvitationInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = DeleteInvitation | DeleteInvitationSuccess | DeleteInvitationError | ResetDeleteInvitation
